import { render } from "./NcrmImportDetails.vue?vue&type=template&id=24e50b74&scoped=true"
import script from "./NcrmImportDetails.vue?vue&type=script&lang=js"
export * from "./NcrmImportDetails.vue?vue&type=script&lang=js"

import "./NcrmImportDetails.vue?vue&type=style&index=0&id=24e50b74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e50b74"]])

export default __exports__